import { useQuery } from "react-query";
import { rolesService } from "../services/roles.service";
import { Role } from "./models/users/role";

export function useRolesQuery() {
  return useQuery<Role[]>(["roles"], () => rolesService.getAllRoles());
}
